import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import { throwError } from 'rxjs';
import * as _ from 'lodash';
import { environment } from 'environments/environment';
import { SharedService } from './shared.service';

@Injectable()
export class HttpService {
  public options: any = {
    withCredentials: true,
  };

  constructor(public http: HttpClient, public router: Router, public sharedService: SharedService) {}

  get(url: string, params: object = {}, isBECall = true) {
    const queryString: string = params ? '?' + this.parseParams(params) : '';
    const requestURL: string = isBECall ? environment.apiURL + url : url;
    let res: any;

    return this.http
      .get(requestURL + queryString, this.options)
      .map((response: any) => {
        try {
          res = response.json();
          if (res.status) {
            if (response.status.toString() === 'session_expired' && localStorage.getItem('userId')) {
              //localStorage.clear();
              localStorage.removeItem('userData');
              location.reload();
              return [];
            }
          }
          if (res.networkData) {
            if (res.networkData.errors) {
              this.router.navigate(['/']).then(() => {
                return;
              });
            }
          }
          return res;
        } catch (err) {
          return response;
        }
      })
      .catch((error: any) => {
        return throwError(error || 'Server error');
      })
      .share();
  }

  post(url: string, params: object = {}) {
    const body: string = this.parseParams(params) + '&ajax=true';
    const options: any = _.cloneDeep(this.options);
    let request: Observable<any>;
    options.headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    request = this.http
      .post(environment.apiURL + url, body, options)
      .map((response: any) => {
        try {
          if (response.status) {
            if (response.status.toString() === 'session_expired' && localStorage.getItem('userId')) {
              //localStorage.clear();
              localStorage.removeItem('userId');
              localStorage.removeItem('userData');
              localStorage.removeItem('userDataSignature');
              location.reload();
              return [];
            }
          }
          if (response.networkData) {
            if (response.networkData.errors) {
              this.router.navigate(['/']).then(() => {
                return;
              });
            }
          }
          return response;
        } catch (err) {
          return response;
        }
      })
      .catch((error: any) => {
        return throwError(error || 'Server error');
      })
      .share();
    return request;
  }

  upload(url: string, params: any, file: any) {
    const formData: FormData = new FormData();
    const headers: Headers = new Headers();

    for (const p in params) {
      if (p) {
        formData.append(p, params[p]);
      }
    }

    formData.append('ajax', 'true');
    formData.append('file', file, file.name);
    headers.append('Accept', 'application/json');

    return this.http
      .post(environment.apiURL + url, formData, this.options)
      .map((res: any) => res)
      .catch((error: any) => Observable.throw(error || 'Server error'))
      .share();
  }

  parseParams(params: any) {
    const urlParams: URLSearchParams = new URLSearchParams();
    for (const param in params) {
      if (this.isObjOrArr(params[param])) {
        for (const item in params[param]) {
          if (this.isObjOrArr(params[param][item])) {
            for (const property in params[param][item]) {
              if (this.isObjOrArr(params[param][item][property])) {
                for (const innerProperty in params[param][item][property]) {
                  urlParams.append(
                    param + '[' + item + ']' + '[' + property + ']' + '[' + innerProperty + ']',
                    params[param][item][property][innerProperty]
                  );
                }
              } else {
                urlParams.append(param + '[' + item + ']' + '[' + property + ']', params[param][item][property]);
              }
            }
          } else {
            urlParams.append(param + '[' + item + ']', params[param][item]);
          }
        }
      } else {
        urlParams.append(param, params[param]);
      }
    }
    return urlParams.toString();
  }

  isObjOrArr(val: any) {
    return Array.isArray(val) || val instanceof Object;
  }
}
